<template>
    <div class="row">

        <div class="col pt-2">


            <!--  Page  -->
            <div class="bg-white rounded py-2 shadow-widget border">

                <!-- Page header -->
                <div class="px-3">

                    <div class="d-flex">

                        <h4>{{ $t('page.categorytypes') }}</h4>

                        <div class="ml-auto align-self-center">

                            <b-button :variant="'primary'" @click="add" class="ml-auto">
                                <font-awesome-icon :icon="'plus'" />
                                {{ $t('default.add')}}
                            </b-button>

                        </div>

                    </div>

                    <span class="text-muted font-weight-light">{{ $t('page.categorytypes_desc') }}</span>

                </div>

                <hr>

                <!-- Page content -->
                <div class="px-5">


                    <v-wait for="category_types">


                        <loading slot="waiting"/>

                        <b-row>
                            <b-col md="4" class="my-2 ml-auto">
                                <b-input-group>
                                    <b-form-input v-model="filter" :placeholder="$t('simple.type_to_search')" />
                                    <b-input-group-append>
                                      <b-btn :disabled="!filter" @click="filter = ''">{{ $t('simple.clear') }}</b-btn>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>
                        </b-row>

                        <b-table responsive bordered hover :items="category_types" :fields="category_type_fields" :filter="filter" class="vh-25">

                            <!-- Actions -->
                            <template slot="cell(actions)" slot-scope="cell">

                              <b-dropdown right :text="$t('simple.actions')" size="sm">

                                <b-dropdown-item @click="edit(cell.item.id)">{{ $t('simple.edit') }}</b-dropdown-item>

                                <b-dropdown-item @click="remove(cell.item.id)">{{ $t('simple.delete') }}</b-dropdown-item>


                              </b-dropdown>

                            </template>

                            <!-- Created at -->
                            <template slot="cell(created_at)" slot-scope="cell">

                                 {{ $moment($moment.utc(cell.item.created_at)).local().format('YYYY-MM-DD HH:mm:ss') }}
                                 
                            </template>

                            <!-- Updated at -->
                            <template slot="cell(updated_at)" slot-scope="cell">

                                 {{ $moment($moment.utc(cell.item.updated_at)).local().format('YYYY-MM-DD HH:mm:ss') }}

                            </template>

                        </b-table>

                    </v-wait>

                </div>
                    

            </div>


        </div>

    </div>
    
</template>

<script>

    import CategoryTypeAdd from './Modal/CategoryTypeAdd.vue'
    import CategoryTypeEdit from './Modal/CategoryTypeEdit.vue'
    import CategoryTypeDelete from './Modal/CategoryTypeDelete.vue'

    import { create } from 'vue-modal-dialogs'

    export default {

        mounted: function () {
            // Component mounted
            console.log('Category Types component mounted.')
        },

        destroyed() {
            // Component destroyed
            console.log('Category Types component destroyed.');
        },

        created: function() {
            // Component created
           this.getCategoryTypes();
        },
        

        data: function() {
            return  {

                category_types_api: '/api/v1/settings/category/types/',
                category_types: [],
                category_type_fields: [
                    { key: 'name', label: this.$t('simple.name'), sortable: true },
                    { key: 'description', label: this.$t('simple.desc'), sortable: true },
                    { key: 'created_at', label: this.$t('simple.created'), sortable: true },
                    { key: 'updated_at', label: this.$t('simple.updated'), sortable: true },
                    { key: 'actions', label: this.$t('simple.actions') },
                ],
                filter: null,
            }
        },
        
        metaInfo: function() {

            return {
                title: this.$t('page.categorytypes'),
            }

        },

        methods: {

            getCategoryTypes: async function(){

                // Start waiting
                this.$wait.start('category_types');

                // Get category types
                await axios.get(this.category_types_api)
                
                  .then((response) => {

                    // response data
                    this.category_types = response.data;

                    // End waiting
                    this.$wait.end('category_types');

                  })
                  .catch((error) => {
                    // Show error
                    Vue.toasted.error(this.$t('simple.error_info'));

                    // End waiting
                    this.$wait.end('category_types');

                  });

            },


            add: async function() {
                // Show CategoryType add modal
                const category_type_add = create(CategoryTypeAdd);

                if (await category_type_add() ){
                    // Refresh account list
                    this.getCategoryTypes();
                }

            },

            edit: async function(id) {
                // Show customer type edit modal
                const category_type_edit = create(CategoryTypeEdit, 'id');

                if (await category_type_edit(id) ){
                    // Refresh customer type list
                    this.getCategoryTypes();
                }

            },

            remove: async function(id) {
                
                // Show customer type remove modal
                const category_type_delete = create(CategoryTypeDelete, 'id');

                if (await category_type_delete(id) ){
                    // Refresh Customer Type list
                    this.getCategoryTypes();
                }

            },

        },
        
    }
</script>